import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { styles } from '../../../../styles/themes/style'

interface IIntervalSwitchProps {
    selectedInterval: string
    saveLabel?: string
    onChange: (interval: string) => void
}

const intervals = [
    { key: 'year', label: 'Yearly' },
    { key: 'month', label: 'Monthly' }
]

const IntervalSwitch: FunctionComponent<IIntervalSwitchProps> = ({ selectedInterval, saveLabel, onChange }) => (
    <Container role="radiogroup" aria-label="Billing period">
        {intervals.map(({ key, label }) => (
            <Option
                key={key}
                type="button"
                role="radio"
                aria-checked={selectedInterval === key}
                $selected={selectedInterval === key}
                onClick={() => onChange(key)}
            >
                {label}
                {key === 'year' && saveLabel && <SaveBadge>{saveLabel}</SaveBadge>}
            </Option>
        ))}
    </Container>
)

const Container = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 4px;
    border-radius: 12px;
    background-color: ${styles.colors.primary100};
`
const Option = styled.button<{ $selected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 84px;
    height: 30px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1.5px solid ${({ $selected }) => $selected ? styles.colors.primary600 : 'transparent'};
    background-color: ${({ $selected }) => $selected ? styles.colors.white : 'transparent'};
    box-shadow: ${({ $selected }) => $selected ? '0 1.3px 2px rgba(0, 0, 0, 0.06), 0 3px 4px rgba(0, 0, 0, 0.08)' : 'none'};
    font-family: NunitoSans;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${styles.colors.black600};
    cursor: pointer;
    transition: all .2s ease;

    &:focus-visible {
        outline: 2px solid ${styles.colors.primary600};
        outline-offset: 1px;
    }
`
const SaveBadge = styled.span`
    display: flex;
    align-items: center;
    height: 20px;
    padding: 0 6px;
    border-radius: 999px;
    background-color: ${styles.colors.primary600};
    color: ${styles.colors.white};
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
`

export default IntervalSwitch
